import isPlainObj from"is-plain-obj";

import{getErrorPluginInfo}from"../info/main.js";

import{assignError}from"./assign.js";












export const setPluginsProperties=(error,plugins)=>
plugins.forEach((plugin)=>{
applyPluginProperties({error,plugin,plugins})
});

const applyPluginProperties=({
error,
plugin,
plugin:{properties,fullName},
plugins
})=>{
if(properties===undefined){
return
}

const info=getErrorPluginInfo({error,plugins,plugin});
const newProps=properties(info);

if(!isPlainObj(newProps)){
throw new TypeError(
`Plugin "${fullName}"'s "properties()" must return a plain object: ${newProps}`
)
}

assignError(error,newProps,plugins)
};